/**
 * Signal that the PMW admin script has loaded successfully.
 *
 * The PHP code sets up a detection mechanism that waits for window.load,
 * then checks if this flag is set. If not, it shows the script blocker warning.
 *
 * This approach ensures:
 * - No false positives on slow-loading pages
 * - Warning only shows when the script is actually blocked
 */
window.pmwAdminScriptLoaded = true;
